import * as React from 'react';
import { Error, Label, LabelSize } from '..';
import { StyleSheet, css } from 'aphrodite';
import { Flex, Box } from '../../CommonUI/Layout';
import { Common } from '../../Assets/styles/common';

interface TextProps {
    onChangeEvent?: (event: React.ChangeEvent<HTMLInputElement>) => void;
    onEnterPress?: (event: React.KeyboardEvent<HTMLInputElement>) => void;
    id?: string;
    label?: string;
    labelSize?: LabelSize;
    value?: string | number;
    disabled?: boolean;
    validationError?: string;
    validate?: (value?: string | number) => boolean;
    type?: string;
}

export class Text extends React.Component<TextProps, {}> {
    constructor(props: TextProps) {
        super(props);
        this.onChange = this.onChange.bind(this);
        this.onEnterPress = this.onEnterPress.bind(this);
        this.validationElements = this.validationElements.bind(this);
    }

    public onChange(event: React.ChangeEvent<HTMLInputElement>) {
        if (this.props.onChangeEvent) {
            this.props.onChangeEvent(event);
        }
    }

    public onEnterPress(event: React.KeyboardEvent<HTMLInputElement>) {
        if (this.props.onEnterPress && event.key === 'Enter') {
            this.props.onEnterPress(event);
        }
    }

    public validationElements() {
        if (this.props.validate && this.props.validate(this.props.value) === false) {
            return {
                errorBox: (<Error text={this.props.validationError} />),
                errorMode: true
            };
        } else {
            return {
                errorBox: '',
                errorMode: false
            };
        }
    }

    public render() {
        const { errorBox, errorMode } = this.validationElements();
        const { id, label, type, value, disabled, labelSize } = this.props;
        return (
                <Box pl={20} pr={20}>
                    <Flex>
                        <Label
                            errorMode={errorMode}
                            htmlFor={id}
                            label={label}
                            labelSize={labelSize}
                        />
                        <Box width="100%" mt="0px">
                            <Flex
                                flexDirection="row"
                                alignItems="flex-start"
                                justifyContent="start"
                            >
                                <input
                                    id={id || ''}
                                    type={type || 'text'}
                                    value={(value === undefined || value === null) ? '' : value}
                                    disabled={disabled}
                                    className={css(styles.text, styles.textPseudo, errorMode && styles.error)}
                                    onChange={this.onChange}
                                    onKeyPress={this.onEnterPress}
                                />
                                {this.props.children}
                            </Flex>
                        </Box>
                        {errorBox}
                    </Flex>

                </Box>
        );
    }
}

const styles = StyleSheet.create({
    text: {
        width: Common.Dimensions.controlWidth,
        minWidth: Common.Dimensions.minControlWidth,
        maxWidth: Common.Dimensions.maxControlWidth,
        height: '40px',
        padding: '0px 12px',
        display: 'block',
        borderRadius: '4px',
        boxShadow: 'inset 0 1px 3px 0 rgba(0, 0, 0, 0.13)',
        backgroundColor: '#ffffff',
        border: 'solid 1px #d4d4d4',
        boxSizing: 'border-box',
        fontFamily: 'Lato',
        fontSize: '14px',
        fontWeight: 'normal',
        fontStyle: 'normal',
        fontStretch: 'normal',
        lineHeight: '1.43',
        letterSpacing: 'normal',
        color: '#292929',
    },
    textPseudo: {
        ':hover': {
            boxShadow: Common.Borders.boxShadowHover,
        },
        ':focus': {
            boxShadow: '0 0 5px 0 #a2d3ff',
            border: 'solid 1px #a2d3ff',
            outlineStyle: 'none',
        },
        ':disabled': Common.disabled,
    },
    error: {
        border: 'solid 1px #fc4c5d',
        borderRadius: '4px 4px 0px 0px',
    }
});
